export const TIMED_PHASES = {
  "wave-once": 1934,
  "phone-enter": 942,
  "phone-exit": 942,
  "sleep-enter": 926,
  "sleep-exit": 926,
  "drag-enter": 414,
  "drag-release": 1730,
};

export const LOOP_DURATIONS = {
  "phone-loop": 896,
  "sleep-loop": 3360,
};

export const PRELOAD_ASSETS = [
  "idle",
  "wave",
  "phone-enter",
  "phone-loop",
  "phone-exit",
  "sleep-enter",
  "sleep-loop",
  "sleep-exit",
  "drag-enter",
  "drag-hold",
  "drag-release",
];

export function initialPlayback(runId = 0) {
  return { action: "idle", phase: "loop", runId };
}

export function playbackAsset({ action, phase }) {
  if (action === "idle" || action === "wave") return action;
  return `${action}-${phase}`;
}

export function playbackDuration({ action, phase }) {
  return TIMED_PHASES[`${action}-${phase}`] ?? 0;
}

export function advancePlayback(state) {
  if (state.action === "wave") {
    return initialPlayback(state.runId + 1);
  }
  if (state.action === "drag") {
    if (state.phase === "enter") {
      return { ...state, phase: "hold", runId: state.runId + 1 };
    }
    if (state.phase === "release") {
      return initialPlayback(state.runId + 1);
    }
    return state;
  }
  if (state.phase === "enter") {
    return { ...state, phase: "loop", runId: state.runId + 1 };
  }
  if (state.phase === "exit") {
    return initialPlayback(state.runId + 1);
  }
  return state;
}

export function requestPlayback(state, nextAction) {
  if (state.action === "drag") return state;
  const isTransitioning =
    state.action === "wave" || state.phase === "enter" || state.phase === "exit";
  if (isTransitioning) return state;

  const isPersistent = state.action === "phone" || state.action === "sleep";
  if (isPersistent) {
    if (nextAction === state.action || nextAction === "idle") {
      return { ...state, phase: "exit", runId: state.runId + 1 };
    }
    return state;
  }

  if (nextAction === "idle") {
    return initialPlayback(state.runId + 1);
  }
  if (nextAction === "wave") {
    return { action: "wave", phase: "once", runId: state.runId + 1 };
  }
  return { action: nextAction, phase: "enter", runId: state.runId + 1 };
}

export function startDragPlayback(state) {
  return { action: "drag", phase: "enter", runId: state.runId + 1 };
}

export function releaseDragPlayback(state) {
  if (state.action !== "drag") return state;
  return { ...state, phase: "release", runId: state.runId + 1 };
}

export function isActionDisabled(state, nextAction) {
  if (state.action === "drag") return true;
  const isTransitioning =
    state.action === "wave" || state.phase === "enter" || state.phase === "exit";
  if (isTransitioning) return true;
  const isPersistent = state.action === "phone" || state.action === "sleep";
  return isPersistent && nextAction !== state.action && nextAction !== "idle";
}
